import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const DcrSuccessIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='120' height='120' viewBox='0 0 120 120' fill='none' sx={sx}>
			<svg
				width='120'
				height='120'
				viewBox='0 0 120 120'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<g clipPath='url(#clip0_5288_32531)'>
					<rect width='120' height='120' rx='60' fill='#F5F5F5' />
					<path
						d='M99.5879 31.3564C100.92 31.3564 102 32.4364 102 33.7685V115.648C102 116.23 101.791 116.794 101.403 117.227C90.716 129.168 76.0969 136.356 60 136.356C44.0242 136.356 29.4116 129.042 18.6145 117.232C18.2158 116.796 18 116.224 18 115.633V33.7685C18 32.4364 19.0799 31.3564 20.4121 31.3564H99.5879Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M55.591 64.0513C56.0626 64.5262 56.8307 64.5262 57.3024 64.0514L74.9479 46.2849C75.4192 45.8103 76.1868 45.8099 76.6585 46.2841L80.6403 50.2862C81.1081 50.7564 81.1084 51.5161 80.641 51.9867L75.252 57.4128L69.0181 63.6894L62.7842 69.9661L59.6673 73.1044L57.4053 75.3819C57.3624 75.4251 57.317 75.4644 57.2696 75.4998C57.2071 75.5464 57.1445 75.5932 57.0895 75.6486C56.7183 76.0226 56.1135 76.0227 55.7422 75.6488L40.5515 60.3547C40.0845 59.8844 40.0844 59.1254 40.5513 58.6551L44.5348 54.6426C45.0065 54.1676 45.7747 54.1675 46.2464 54.6425L55.591 64.0513Z'
						fill='#E3F2FD'
					/>
					<path
						d='M40.1992 59.5651L44.1808 55.5728C44.6521 55.1003 45.4175 55.1003 45.8887 55.5728L55.3631 65.0725C55.8343 65.545 56.5997 65.545 57.0709 65.0725L75.2835 46.8113C75.7648 46.3286 76.5502 46.3405 77.0167 46.8375L80.9992 51.0802M78.8837 53.2014L57.0709 75.0725C56.5997 75.545 55.8343 75.545 55.3631 75.0725L49.5681 69.262M46.2437 65.9287L40.1992 59.8681'
						stroke='#1565C0'
						strokeWidth='1.8'
						strokeMiterlimit='10'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M81.6004 84.5039H38.4004V90.5039H81.6004V84.5039Z'
						fill='#E3F2FD'
					/>
					<path
						d='M81.6004 96.4307H38.4004V102.431H81.6004V96.4307Z'
						fill='#E3F2FD'
					/>
					<path
						d='M71.4008 108.329H49.8008V114.329H71.4008V108.329Z'
						fill='#E3F2FD'
					/>
					<path
						d='M38.4004 101.729H61.2347'
						stroke='#1565C0'
						strokeWidth='1.8'
						strokeMiterlimit='10'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M66.7891 101.729L81.6005 101.729'
						stroke='#1565C0'
						strokeWidth='1.8'
						strokeMiterlimit='10'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M38.4004 89.8486H81.6004'
						stroke='#1565C0'
						strokeWidth='1.8'
						strokeMiterlimit='10'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M49.1992 114.328H70.7992'
						stroke='#1565C0'
						strokeWidth='1.8'
						strokeMiterlimit='10'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M20.502 32.2568H100.1C100.935 32.2568 101.612 32.9335 101.612 33.7686V115.583C101.612 115.951 101.479 116.301 101.241 116.565C90.6555 128.324 76.1994 135.381 60.3008 135.381C44.5294 135.381 30.075 128.203 19.3711 116.562C19.1269 116.297 18.9903 115.942 18.9902 115.568V33.7686C18.9902 32.9335 19.6669 32.2568 20.502 32.2568Z'
						stroke='#0057B2'
						strokeWidth='1.8'
					/>
				</g>
				<defs>
					<clipPath id='clip0_5288_32531'>
						<rect width='120' height='120' rx='60' fill='white' />
					</clipPath>
				</defs>
			</svg>
		</SvgIcon>
	);
};
